import classNames from 'classnames';
import React from 'react';
import { Link } from 'react-router-dom';

export type TabTitleProps = {
  title: string;
  tabKey: string;
  selectedTab: string;
  setSelectedTab: (index: string) => void;
  isDisabled?: boolean;
  link?: string;
};

export const TabTitle: React.FC<TabTitleProps> = ({
  title,
  setSelectedTab,
  tabKey,
  selectedTab,
  isDisabled,
  link,
}: TabTitleProps) => {
  return (
    <Link
      to={{
        pathname: link,
      }}
    >
      <button
        className={classNames(
          'focus:text-primary h-full px-4 py-2 font-sans font-semibold uppercase focus:outline-none',
          {
            'text-grey-200 border-grey-500 border-b':
              selectedTab !== tabKey && isDisabled,
            'text-grey-700 border-grey-500 hover:text-primary border-b':
              selectedTab !== tabKey && !isDisabled,
            'border-primary text-primary border-b-4': selectedTab === tabKey,
          },
        )}
        onClick={() => setSelectedTab(tabKey)}
        disabled={isDisabled}
      >
        {title}
      </button>
    </Link>
  );
};
